<sw-header></sw-header>
<sw-sidebar></sw-sidebar>

<main class="app-main" [class.sidebar-collapsed]="collapsed()">
  <router-outlet></router-outlet>
</main>

<sw-notification-toast></sw-notification-toast>
<sw-feature-tour></sw-feature-tour>
<sw-help-panel></sw-help-panel>
<sw-confirm-dialog></sw-confirm-dialog>
<sw-idle-timeout></sw-idle-timeout>
